// extracted by mini-css-extract-plugin
module.exports = {"container":"KioskLockedActions_container__nYgGC","menuItem":"KioskLockedActions_menuItem__BrLrZ","item":"KioskLockedActions_item__HN6rj"};